import React from 'react'

import { loadBusinessData } from '@disco/state-management/actions/UserActions'

import ChargebeePricingEmbed from 'components/chargebee-pricing-embed'
import DiscoModal from 'components/ui/disco-modal'
import { trialExpiredModalStyles } from 'components/utils/modalStyles'

import useEventListener from 'hooks/use-event-listener'
import { useInterval } from 'hooks/use-interval'
import { useDispatch } from 'hooks/use-redux'

const RELOAD_INTERVAL_MS = 10 * 1000

// can't be dismissed; closes once business data shows the trial is no longer expired
const TrialExpiredModal = (): React.ReactNode => {
  const dispatch = useDispatch()

  // Chargebee doesn't tell the page about payment, and checkout may finish in another tab
  const reloadBusiness = () => {
    if (document.hidden) return
    dispatch(loadBusinessData('WITHOUT_REALTIME_TRACK_COUNT'))
  }
  useInterval(reloadBusiness, RELOAD_INTERVAL_MS)
  // not window focus: that also fires on every click back out of Chargebee's iframe
  useEventListener('visibilitychange', reloadBusiness, document)

  return (
    <DiscoModal contentLabel="Choose a plan" style={trialExpiredModalStyles}>
      <ChargebeePricingEmbed />
    </DiscoModal>
  )
}

export default TrialExpiredModal
